import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Footer from "./Footer"

const Container = styled.div`
  padding-top: 10px;
  padding-bottom: 60px;
`

function PageWrapper({ children }) {
  return (
    <Container id="page-wrapper">
      {children}
      <Footer />
    </Container>
  )
}

PageWrapper.propTypes = {
  children: PropTypes.node,
}

PageWrapper.defaultProps = {
  children: null,
}

export default PageWrapper



// WEBPACK FOOTER //
// ./src/components/layout/PageWrapper.jsx